import theme from "./theme/index";
import catalogue from "./catalogue/index";
import thanks from "./thanks/index";
import headline from "./headline/index";
import nodule from "./nodule/index";
import customTemp from "./custom/index.js";

const customData = {
  theme: (params: any) => {
    let { temp, customTheme } = params;
    let generationFun = customTheme
      ? customTemp[customTheme]["theme"]
      : theme[Math.floor(Math.random() * theme.length)];
    if (!customTheme && temp > 0) generationFun = theme[temp - 1];
    return generationFun(params);
  },
  catalogue: (params: any) => {
    let { temp, customTheme } = params;
    let generationFun = customTheme
      ? customTemp[customTheme]["catalogue"]
      : catalogue[Math.floor(Math.random() * catalogue.length)];
    if (!customTheme && temp > 0) generationFun = catalogue[temp - 1];
    return generationFun(params);
  },
  headline: (params: any) => {
    let { temp, customTheme } = params;
    let generationFun = customTheme
      ? customTemp[customTheme]["headline"]
      : headline[Math.floor(Math.random() * headline.length)];
    if (!customTheme && temp > 0) generationFun = headline[temp - 1];
    return generationFun(params);
  },
  nodule: (params: any) => {
    let { temp, customTheme, noduleType } = params;

    if (!nodule[noduleType]) return null;
    let generationFun =
      nodule[noduleType][Math.floor(Math.random() * nodule[noduleType].length)];
    if (!customTheme && temp > 0) generationFun = nodule[noduleType][temp - 1];
    return generationFun(params);
  },
  thanks: (params: any) => {
    let { temp, customTheme } = params;
    let generationFun = customTheme
      ? customTemp[customTheme]["thanks"]
      : thanks[Math.floor(Math.random() * thanks.length)];
    if (!customTheme && temp > 0) generationFun = thanks[temp - 1];
    return generationFun(params);
  },
};

const getNodeList = (pptNode: any) => {
  const list: any = [];
  const splitNode = (node: any) => {
    if (node.children?.length > 0) {
      list.push(node);
      node.children.forEach((item: any) => {
        splitNode(item);
      });
    } else {
      if (node.type) list.push(node);
    }
  };
  splitNode(pptNode);
  const catalogueNode = {
    type: "catalogue",
    title: "目录",
    list: pptNode.children.map((item: any) => item.title),
  };
  list.splice(1, 0, catalogueNode);
  return list;
};

const generationPPtJson = async (
  pptNode: any,
  color?: string,
  customTheme?: string | undefined,
  temp = 0
) => {
  const nodeList = getNodeList(pptNode);
  let headlineNum = 0;
  const headlineTemp = Math.floor(Math.random() * headline.length) - 0 + 1;
  const handleNode = async (item: any) => {
    const type = item.type;
    switch (type) {
      case "theme":
        return await customData.theme({
          node: item,
          color: color,
          temp: temp,
          customTheme,
        });
      case "catalogue":
        return await customData.catalogue({
          node: item,
          color: color,
          temp: temp,
          customTheme,
        });
      case "headline":
        headlineNum++;
        let num = headlineNum;
        let headlineStr = "";
        if (num - 0 < 10) headlineStr = "0" + num;
        return await customData.headline({
          node: item,
          color: color,
          num: headlineStr,
          temp: headlineTemp,
          customTheme,
        });
      case "nodule":
        let noduleType = "nodule";
        const child = item.children.length;
        noduleType += child;
        const noduleJson = await customData.nodule({
          node: item,
          color: color,
          noduleType: noduleType,
          temp: temp,
          customTheme,
        });
        if (noduleJson) return noduleJson;
        break;
    }
  };
  // 使用map和Promise.all来处理异步操作
  let jsonList = await Promise.all(nodeList.map(handleNode));
  const thanksJson = await customData.thanks({
    temp: temp,
    color: color,
    customTheme,
  });
  jsonList.push(thanksJson);
  return jsonList;
};

export default generationPPtJson;
